import * as product from '@/services/rest-api/lib/product/product'

const translate = (t, key, fallback, params = {}) => {
  if (typeof t !== 'function') return fallback

  const translated = t(key, params)

  return translated === key ? fallback : translated
}

export const getLoadFields = (t) => [
  {
    name: 'product_id',
    label: translate(t, 'delivery.loadsTable.fields.productName', 'Nama Produk'),
    placeholder: translate(t, 'delivery.loadsTable.placeholder.selectProduct', 'Pilih Produk'),
    modalTitle: translate(t, 'delivery.loadsTable.placeholder.selectProduct', 'Pilih Produk'),
    isEditable: true,
    isSortable: true,
    type: 'value-help-v2',
    validation: 'required',
    trackBy: 'id',
    displayedBy: 'name',
    listGetter: product.get,
    thStyle: 'width: 300px',
    tdStyle: 'max-width: 300px',
    tableFields: [
      {
        label: translate(t, 'delivery.loadsTable.fields.productName', 'Nama Produk'),
        key: 'name',
        isSortable: true,
      },
      {
        label: translate(t, 'delivery.fields.minTemperature', 'Min. Temperatur'),
        key: 'product_type.product_category.min_temperature',
        isSortable: true,
        formatter: (value) => ((value ?? '') === '' ? '-' : `${value} °C`),
        scopes: ['tms-cold-chain:read'],
      },
      {
        label: translate(t, 'delivery.fields.maxTemperature', 'Max. Temperatur'),
        key: 'product_type.product_category.max_temperature',
        isSortable: true,
        formatter: (value) => ((value ?? '') === '' ? '-' : `${value} °C`),
        scopes: ['tms-cold-chain:read'],
      },
      {
        label: translate(t, 'delivery.loadsTable.fields.productType', 'Jenis Produk'),
        key: 'product_type.name',
        isSortable: true,
      },
      {
        label: translate(t, 'delivery.fields.productCategory', 'Kategori Produk'),
        key: 'product_type.product_category.name',
        isSortable: true,
      },
    ],
  },
  {
    name: 'product_type',
    label: translate(t, 'delivery.loadsTable.fields.productType', 'Jenis Produk'),
    isSortable: true,
    thStyle: 'width: 200px',
  },
  {
    name: 'quantity',
    label: translate(t, 'delivery.loadsTable.fields.quantity', 'Kuantitas'),
    _type: 'number',
    placeholder: translate(t, 'delivery.loadsTable.placeholder.enterQuantity', 'Masukkan Kuantitas'),
    validation: 'bail|required|number|min:1,value|max:10000000,value',
    'validation-messages': {
      min: translate(t, 'delivery.loadsTable.validation.minQuantity', 'Harus lebih dari 0'),
      max: translate(t, 'delivery.loadsTable.validation.maxQuantity', 'Maksimal 10,000,000'),
    },
    value: 1,
    isEditable: true,
    isSortable: true,
    thStyle: 'width: 100px',
  },
  {
    name: 'uom',
    label: translate(t, 'delivery.loadsTable.fields.unit', 'Satuan Kuantitas'),
    placeholder: translate(t, 'delivery.loadsTable.placeholder.selectUnit', 'Pilih Satuan'),
    isEditable: true,
    validation: 'required',
    type: 'select-resourceful-v2',
    trackBy: 'name',
    optionsGetter: null,
    optionLabelFn: ({ item }) => item.name,
    thStyle: 'width: 200px',
    tdStyle: 'min-width: 200px',
  },
  {
    name: 'total_weight',
    label: translate(t, 'delivery.loadsTable.fields.weight', 'Berat'),
    isSortable: true,
    afterText: 'Kg',
    thStyle: 'width: 200px',
  },
  {
    name: 'total_volume',
    label: translate(t, 'delivery.fields.volume', 'Volume'),
    isSortable: true,
    afterText: 'Cbm',
    thStyle: 'width: 200px',
  },
  {
    name: 'min_temperature',
    label: translate(t, 'delivery.fields.minTemperature', 'Min. Temperatur'),
    isSortable: true,
    thStyle: 'width: 200px',
    formatter: (value) => ((value ?? '') === '' ? '- °C' : `${value} °C`),
    scopes: ['tms-cold-chain:read'],
  },
  {
    name: 'max_temperature',
    label: translate(t, 'delivery.fields.maxTemperature', 'Max. Temperatur'),
    isSortable: true,
    thStyle: 'width: 200px',
    formatter: (value) => ((value ?? '') === '' ? '- °C' : `${value} °C`),
    scopes: ['tms-cold-chain:read'],
  },
  {
    name: 'note',
    label: translate(t, 'delivery.loadsTable.fields.notes', 'Catatan'),
    placeholder: translate(t, 'delivery.loadsTable.placeholder.writeHere', 'Tulis disini...'),
    isEditable: true,
    type: 'text',
    thStyle: 'width: 200px',
  },
]
